const doctorInitState = {
    doctor: [],
    pagination: {},
    doctorDetailsData: {}
};

export default doctorInitState;
